import Data from "../types/Data";

export default function setVenmo(data: Data, venmo: string): Data {
  let newData = {
    ...data,
    venmo: venmo.trim().replace(/@/g, ""),
  };
  return newData;
}
